import ListRow from '../../../common/components/list-row/list-row';
import StatusPill from '../../../common/components/status-pill/status-pill';
import RelativeTime from '../../../common/components/relative-time/relative-time';
import { ATTENTION_KIND_LABEL } from '../../../core/constants/domain';
import { ROUTES } from '../../../core/constants/routes';
import { nameOf } from '../../../global/contexts/catalogs/catalogs';
import { useTaskReviewRounds } from '../../../global/contexts/work/work';

import '../styles/decision-queue.css';

function FindingSummary({ taskId }) {
    const { data } = useTaskReviewRounds(taskId);
    const open = data?.items.find((round) => round.isOpen);
    if (!open) return null;
    const { cumple, incumple, no_comprobado: unchecked } = open.summary;
    return (
        <span className="decision-queue__findings">
            <span>{cumple} cumplen</span>
            {incumple > 0 && <span className="decision-queue__finding--bad">{incumple} incumplen</span>}
            {unchecked > 0 && <span className="decision-queue__finding--unknown">{unchecked} sin comprobar</span>}
        </span>
    );
}

function attentionTarget(item) {
    if (item.resourceType === 'task' && item.resourceId) return ROUTES.TASK(item.resourceId);
    if (item.resourceType === 'position') return ROUTES.TEAMS;
    return null;
}

export default function DecisionQueue({ reviews, attention, projects }) {
    return (
        <div className="decision-queue">
            {reviews.length > 0 && (
                <ul className="decision-queue__list" aria-label="Revisiones esperando tu decisión">
                    {reviews.map((task) => (
                        <ListRow
                            key={task.id}
                            to={ROUTES.REVIEW(task.id)}
                            tone="waiting"
                            eyebrow={`Revisión · ${nameOf(projects, task.projectId, 'Proyecto')}`}
                            title={task.title}
                            meta={(
                                <>
                                    <FindingSummary taskId={task.id} />
                                    <span>Entregada <RelativeTime value={task.updatedAt} /></span>
                                </>
                            )}
                        />
                    ))}
                </ul>
            )}
            {attention.length > 0 && (
                <ul className="decision-queue__list" aria-label="Avisos de atención">
                    {attention.map((item) => (
                        <ListRow
                            key={item.id}
                            to={attentionTarget(item)}
                            tone="blocked"
                            eyebrow={`${ATTENTION_KIND_LABEL[item.kind] ?? item.kind} · ${nameOf(projects, item.projectId, 'Proyecto')}`}
                            title={item.what}
                            meta={<span>{item.detail}</span>}
                            trailing={item.validity === 'vigente' ? <StatusPill tone="blocked" hasDot={false}>Vigente</StatusPill> : null}
                        />
                    ))}
                </ul>
            )}
        </div>
    );
}
